const ControlsPlus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 6.99994L16 16.1924M16 16.1924L6.80759 16.1923M16 16.1924L16 25.3847M16 16.1924L25.1924 16.1923"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ControlsPlus;
